
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.906 9.994a1.355 1.355 0 01-1.353 1.354h-5.205v5.205a1.348 1.348 0 11-2.695 0v-5.205H3.448a1.348 1.348 0 110-2.695h5.204V3.448a1.348 1.348 0 112.696 0v5.204h5.205a1.353 1.353 0 011.353 1.342z","fill-rule":"evenodd"}})])
          )
        }
      }
    